<template>
<el-drawer
    :title="$t('salesRecord.hangRecord')"
    v-if="hangVisible"
    size="95%"
    :visible.sync="hangVisible"
    @close="close">
    <section class="row">
      <asideContent ref="ording" invoicesType="1" @sendObj="getCurOrderObj" style="margin-top:-10px;"></asideContent>
      <section class="section-main" v-if="orderId"
        v-loading="infoDetailLoading"
        :element-loading-text="$t('salesRecord.loadingText')"
        element-loading-spinner="el-icon-loading">
        <section class="goods">
          <section class="hang-table">
            <div class="goods-top row align-center" style="border-bottom:1px solid #e1e1e1;width:100%;margin-bottom:15px;">
              <span style="margin-right: 10px;height: 20px;width: 4px;background: #067cf2;"></span>
              <p>{{$t('salesRecord.goodsInfo')}}</p>
            </div>
            <grid-manager v-if="goodsTable.length" :option="gridOption"></grid-manager>
            <div class="table-total row space-end align-center" v-if="orderData">
              <div>{{$t('salesRecord.totalItems', {count: orderData.totalCount || "0"})}}</div>
              <div>{{$t('salesRecord.totalAmount')}}：<span>{{ orderData.totalRealPrice || "0.00" }}đ</span></div>
            </div>
          </section>

          <section class="goods-card">
            <template v-if="orderData">
              <div class="goods-title row align-center" style="border-bottom:1px solid #e1e1e1;width:98%;">
                <span style="margin-right: 10px;height: 20px;width: 4px;background: #067cf2;"></span>
                <p>{{$t('salesRecord.documentInfo')}}</p>
              </div>
              <div class="row space-around goods-obj">
                <div class="goods-item">
                  <div>
                    {{$t('salesRecord.salesStatus')}}：<span>{{$t('salesRecord.pending')}}</span>
                  </div>
                  <div>
                    {{$t('salesRecord.storeName')}}：<span>{{ orderData.deptName }}</span>
                  </div>
                  <div>
                    {{$t('salesRecord.performanceMethod')}}：<span>{{
                      orderData.brokerage === '1'
                        ? $t('salesRecord.personalPerformance')
                        : orderData.brokerage === '2'
                        ? $t('salesRecord.teamPerformance')
                        : orderData.brokerage === '3'
                        ? $t('salesRecord.distribution')
                        : ""
                    }}</span>
                  </div>
                </div>
                <div class="goods-item">
                  <div>
                    {{$t('salesRecord.salesOrderNo')}}：<span>{{ orderData.orderNo }}</span>
                  </div>
                  <div>
                    {{$t('salesRecord.orderNature')}}：<span>{{ orderData.orderTypeTitle }}</span>
                  </div>
                  <div v-if="orderData.brokerage === '1' && orderData.shoppingGuideName">
                    {{$t('salesRecord.salesperson')}}：<span>{{ orderData.shoppingGuideName }}</span>
                  </div>
                </div>
                <div class="goods-item">
                  <div>
                    {{$t('salesRecord.documentSource')}}：<span>{{
                      orderData.source === '1' ? $t('salesRecord.mobile') : orderData.source === '2' ? $t('salesRecord.client') : ''
                    }}</span>
                  </div>
                  <div>
                    {{$t('salesRecord.creationTime')}}：<span>{{ orderData.createTime }}</span>
                  </div>
                  <div v-if="orderData.createTerminalTitle">{{$t('salesRecord.createOrderCashier')}}：<span>{{orderData.createTerminalTitle}}</span></div>
                </div>
              </div>
              <div class="row" style="margin: -8px 10px 0;" v-if="orderData.brokerage === '2' && orderData.shoppingGuideName">
                <span style="color:#999;">{{$t('salesRecord.teamMembers')}}：</span><span class="description">{{ orderData.shoppingGuideName }}</span>
              </div>
            </template>
          </section>
          <section class="goods-card">
            <template v-if="vipData && vipData.phone">
              <div class="goods-title row align-center" style="border-bottom:1px solid #e1e1e1;width:98%;margin-bottom:15px;">
                <span style="margin-right: 10px;height: 20px;width: 4px;background: #067cf2;"></span>
                <p>{{$t('salesRecord.memberInfo')}}</p>
              </div>
              <div class="row space-around goods-obj">
                <div class="goods-item">
                  <div>
                    {{$t('salesRecord.memberNickname')}}：<span>{{ vipData.nickname }}</span>
                  </div>
                  <div>
                    {{$t('salesRecord.memberCardNo')}}：<span>{{ vipData.cardNumber }}</span>
                  </div>
                  <div>
                    {{$t('salesRecord.totalConsumptionAmount')}}：<span>{{ vipData.totalSellAmount }}</span>
                  </div>
                  <div>
                    {{$t('salesRecord.unitPrice')}}：<span>{{ vipData.unitPrice }}</span>
                  </div>
                </div>
                <div class="goods-item">
                  <div>
                    {{$t('salesRecord.cardOpeningTime')}}：<span>{{ vipData.createTime }}</span>
                  </div>
                  <div>
                    {{$t('salesRecord.totalConsumptionCount')}}：<span>{{ vipData.totalSellCount }}</span>
                  </div>
                  <div>
                    {{$t('salesRecord.memberPoints')}}：<span>{{ vipData.integralBalance }}</span>
                  </div>
                </div>
                <div class="goods-item">
                  <div>
                    {{$t('salesRecord.phoneNumber')}}：<span>{{ vipData.phone }}</span>
                  </div>
                  <div>
                    {{$t('salesRecord.cardIssuingStore')}}：<span>{{ vipData.deptName }}</span>
                  </div>
                  <div>
                    {{$t('salesRecord.averageConsumptionAmount')}}：<span>{{ vipData.avgSellAmount }}</span>
                  </div>
                  <div>
                    {{$t('salesRecord.memberBalance')}}：<span>{{ vipData.accountBalance }}</span>
                  </div>
                </div>
              </div>
            </template>
          </section>
        </section>
        <section class="bot-fixed row align-center">
          <div class="tools-btn" @click="deleteCurHang" style="background: #43435C;">{{$t('salesRecord.deleteHang')}}</div>
          <div class="tools-btn" @click="sureFetch" style="background: #DD8595;">{{$t('salesRecord.sureHang')}}</div>
        </section>
      </section>
      <section class="section-main" style="background: #fff" v-else>
        <noDataState :textDesc="$t('salesRecord.noOrderData')" marginTop="280"></noDataState>
      </section>
    </section>
</el-drawer>
</template>

<script>
import asideContent from "@/views/salesRecord/components/asideContent";
import noDataState from "@/components/noDataState.vue";
import { takeOutPendingList, queryInvoicesInfo } from "@/libs/http/modules/posOrder";
export default {
  components: {
    asideContent,
    noDataState,
  },
  data() {
    return {
      gridOption: {
        gridManagerName: "hangRecordGrid",
        firstLoading: true,
        height: "400px",
        isCombSorting: true,
        supportAutoOrder: false,
        supportCheckbox: false,
        supportConfig: true,
        disableAutoLoading: true,
        supportMenu: false,
        disableBorder: true,
        disableLine: true,
        columnData: [
          {
            key: "goodsName",
            text: this.$t('gridManage.columnGoodsInfo'),
            align: "center",
            width: "350px",
            template: () => {
              return `
                <div class="row align-center" style="text-align:left;">
                  <div style="position:relative;overflow:hidden;width:102px;height:92px;border-radius:4px;flex-shrink: 0;">
                    <el-image v-if="row.goodsImg && row.goodsImg[0]" style="width:102px;height:92px;border-radius:4px;float:left;" :preview-src-list="row.goodsImg" :src="row.goodsImg[0]"></el-image>
                    <div class="row align-center space-center" v-else style="width:102px;height:92px;border-radius:4px;text-align:center;color:#999;background:#f5f5f5;white-space: pre-wrap;">{{$t('gridManage.noGoodsImage')}}</div>
                    <div v-if="row.activeId || [0, 1, 2, 3].includes(row.couponType)"
                      style="
                      width:70px;height:22px;line-height:22px;position:absolute;top:4px;right:-19px;transform: rotate(45deg);text-align:center;
                      background: linear-gradient(-90deg, #EC4620, #F08702, #F7D400);color:#fff;font-size:12px;">
                      {{row.activeId ? $t('gridManage.activity') : $t('gridManage.writeOff')}}
                    </div>
                  </div>
                  <div class="column" style="margin-left:10px;flex:1;">
                    <template v-if="![1, 2].includes(row.couponType)">
                      <div style="font-size:18px;color:#333;">{{row.goodsName}}</div>
                      <div style="font-size:14px;color:#999;margin:10px 0;">{{$t('gridManage.goodsNo')}}：{{row.goodsNo}}</div>
                      <div style="font-size:14px;color:#999;">{{$t('gridManage.goodsBarCode')}}：{{row.barCode}}</div>
                    </template>
                    <template v-else>
                      <div>{{row.couponTypeName}}</div>
                      <div style="width: 100%;white-space: pre-wrap;">{{row.name}}</div>
                    </template>
                  </div>
                </div>
              `;
            },
          },
          {
            key: "colorDesc",
            text: this.$t('gridManage.columnAttr'),
            align: "center",
            width: "150px",
            template: () => {
              return `
                        <div v-if="row.attrList" class="row space-center align-center text-center" style="border:1px solid #DEEEF9;background:#fff;color:#333;line-height:26px;border-radius:2px;cursor:pointer;">
                            <p v-for="(item, index) in row.attrList.slice(0,2)" :key="item.code" style="">{{item.value}}
                                <span v-if="index == 0" style="margin:0 3px;">,</span>
                            </p>
                        </div>
                    `;
            },
          },
          {
            key: "number",
            text: this.$t('gridManage.number'),
            align: "center",
            width: "120px",
            template: () => {
              return `
                        <div style="font-size:20px;">
                            {{row.number}}
                        </div>
                        `;
            },
          },
          {
            key: "unitRealPrice",
            text: this.$t('gridManage.realPriceUnit'),
            align: "center",
            width: "120px",
            template: () => {
              return `
                        <div v-if="![1, 2].includes(row.couponType)" class="row align-center space-center">
                            <span style="color:#666;font-size:20px;">{{row.unitRealPrice}}đ</span>
                        </div>
                    `;
            },
          },
          {
            key: "tagPrice",
            text: this.$t('gridManage.tagPrice'),
            align: "center",
            template: () => {
              return `
                        <div class="row align-center space-center">
                            <span style="font-size:20px;">{{row.tagPrice}}đ</span>
                        </div>
                    `;
            },
          },
          {
            key: "discount",
            text: this.$t('gridManage.discount'),
            align: "center",
            template: () => {
              return `
                        <div v-if="![1, 2].includes(row.couponType)" class="row align-center space-center">
                            <span style="font-size:20px;">{{(row.unitRealPrice / row.tagPrice * 100).toFixed(2)}}%</span>
                        </div>
                    `;
            },
          },
          {
            key: "money",
            text: this.$t('gridManage.totalPrice'),
            align: "center",
            template: () => {
              return `
                        <div class="row align-center space-center" style="color:#F8475F;font-size:20px;">
                            {{row.totalRealPrice}}đ
                        </div>
                    `;
            },
          },
        ],
        ajaxData: this.showGoodsTable
      },
      goodsTable: [],
      orderData: null,
      vipData: null,
      orderId: '',
      invoicesNo: "",
      infoDetailLoading: false,
      hangVisible: true,
      hasCoupon: false
    };
  },
  created(){
    this.$nextTick(()=>{
      this.$refs.ording.queryHangList();
    })
  },
  methods: {
    close(){
      this.$emit('close');
    },
    getCurOrderObj(e) {
      if (e && e.id && e.invoicesNo) {
        this.orderId = e.id;
        this.invoicesNo = e.invoicesNo;
        this.queryInvoices(e.first);
      } else {
        this.orderId = "";
        this.invoicesNo = "";
      }
    },
    queryInvoices() {
      this.infoDetailLoading = true;
      queryInvoicesInfo({
        orderId: this.orderId
      })
      .then(data => {
        if (data.storeInfo) {
          let list = []
          if(data.couponInfoList && data.couponInfoList.length){
            this.hasCoupon = true
            data.couponInfoList.forEach(item=>{
              if([1, 2].includes(item.couponType)){
                list.push(item)
              }
            })
          }else{
            this.hasCoupon = false
          }
          this.goodsTable = [...data.storeInfo, ...list];
          GridManager.refreshGrid(this.gridOption.gridManagerName);
        }
        this.orderData = data.orderInfo || null;
        this.vipData = data.memberInfo || null;
        setTimeout(()=>{
          this.infoDetailLoading = false;
        },500);
      })
      .catch(err => {
        this.$message({
          type: "error",
          message: err,
          duration: 2000,
          showClose: true,
        });
        this.infoDetailLoading = false;
      });
    },
    showGoodsTable() {
      if (this.goodsTable.length) {
        return new Promise((resolve, reject) => {
          const tableData = {
            data: this.goodsTable,
          };
          resolve(tableData);
        });
      }
    },
    deleteCurHang() {
      let strText = ''
      if(this.hasCoupon){
        strText = `${this.$t('salesRecord.hangDeleteContent')}<br/><br/>${this.$t('salesRecord.hangUseOtherThreeCoupon')}`
      }else{
        strText = this.$t('salesRecord.hangDeleteContent')
      }
      this.$confirm(strText, this.$t('salesRecord.hangDeleteTips'), {
        dangerouslyUseHTMLString: true
      }).then(() => {
        this.$refs.ording.deleteCurOrding(this.hasCoupon)
      }).catch((err) => {})
    },
    sureFetch() {
      this.$confirm(this.$t('salesRecord.getHangDataConfirm'), this.$t('salesRecord.getHangDataTip')).then(() => {
		    const cashierItem = JSON.parse(this.$cache.local.get('cashierDeskItem'))
        this.infoDetailLoading = true;
        takeOutPendingList({
          isUpdate: 'N',
          id: this.orderId,
          terminalId: cashierItem ? cashierItem.id : ''
        }).then(data => {
          this.$emit('getOrder', data);
          this.$refs.ording.delecardList();
          this.infoDetailLoading = false;
          this.close();
        }).catch(err => {
          this.infoDetailLoading = false;
          this.$message({ type: "error", message: err, duration: 2000, showClose: true });
        });
      }).catch(err => {});
    },
  },
};
</script>

<style lang="scss" scoped>
.description {
  display: inline-block;
  line-height: 20px;
}
.section-main {
  width: calc(100% - 520px);
  height: calc(100vh - 90px);
  margin-top: 10px;
  position: relative;
  .bot-fixed {
    position: absolute;
    bottom: 0;
    width: 100%;
    background: #fff;
    height: 60px;
    box-shadow: 0px -2px 16px 0px rgba(4, 51, 97, 0.1);
    border-radius: 2px;
    font-family: "font-Regular";
    z-index: 9;
    .tools-btn {
      border-radius: 4px;
      color: #fff;
      padding: 0 10px;
      text-align: center;
      line-height: 40px;
      margin-left: 10px;
      cursor: pointer;
    }
  }
}
.goods {
  height: calc(100vh - 140px);
  overflow: auto;
  .goods-top {
    font-family: "font-Medium";
    color: #656d78;
    padding-bottom: 12px;
  }
  .hang-table {
    background: #fff;
    padding: 0 10px;
    .table-total {
      height: 50px;
      border-top: 1px solid #f5f5f5;
      font-family: "font-Light";
      > div {
        margin-right: 20px;
      }
      span {
        color: #f8475f;
        font-size: 20px;
        font-family: "font-Medium";
      }
    }
  }
  .goods-card {
    background: #fff;
    margin-top: 10px;
    font-family: "font-Light";
    font-size: 14px;
    .goods-title {
      font-size: 18px;
      font-family: "font-Medium";
      color: #656d78;
      width: 180px;
      padding: 10px 0;
      margin: 0 10px;
    }
    .goods-obj {
      flex: 1;
      color: #999;
      padding: 10px;
      .goods-item {
        width: calc(100% / 3);
        div {
          line-height: 30px;
          span {
            color: #000;
          }
        }
      }
    }
  }
}
</style>

<style>
.hang-table .table-wrap {
  height: auto !important;
}
</style>